export default "__VITE_ASSET__CCe4xZN7__"